import React from "react";
import { Flex } from "antd";
import { Empty } from "antd";
import { Spinner } from "reactstrap";
import { AntSelect } from "@/CommonElements/AntSelect";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { usePortsQuery } from "@/services/basicData";

/**
 * Shared select for ports (airports / entry ports) with search.
 * Used e.g. for airport_code in Create Flight form.
 * For edit-mode row data, use useFlightEditRow() from @/Pages/Makkah/Departure/FlightEditContext.
 */
export const SelectPorts = (props) => {
  const { getLocalizedText } = useLocalizedText();
  const { data: portsRes, isLoading, isError } = usePortsQuery({ per_page: 500 });
  // Support common API response shapes: { data: { data: [] } }, { data: [] }, or { data: { ports: [] } }
  const raw = portsRes?.data;
  const rawData = Array.isArray(raw) ? raw : raw?.data ?? raw?.ports;
  const ports = Array.isArray(rawData) ? rawData : [];

  const options = ports
    .filter((port) => port != null && (port.id != null || port.code != null))
    .map((port) => {
      const localized = getLocalizedText(port?.name_ar, port?.name_en);
      const label =
        (localized && localized.trim() !== "" && localized !== "-" ? localized : null) ||
        port?.name ||
        port?.name_ar ||
        port?.name_en ||
        port?.code ||
        String(port?.id ?? port?.code ?? "");
      return {
        value: String(port?.id ?? port?.code ?? ""),
        label: String(label),
      };
    });

  return (
    <AntSelect
      {...props}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toString().toLowerCase().includes((input || "").toLowerCase())
      }
      options={options}
      notFoundContent={
        isLoading ? (
          <Flex align="center" justify="center">
            <Spinner size="sm" />
          </Flex>
        ) : isError ? null : (
          <Empty />
        )
      }
    />
  );
};
